import common from "./common";
import old from "./old";

export const dark = {
  old,
  fonts: common.fonts,
  colors: common.colors,
  text: {
    default: '#A1A1AA',
    secondary: '#D4D4D8',
    headline: '#FFFFFF',
    highlight: '#FFFFFF',
    error: '#F43F5E',
  },
  button: {
    primary: {
      default: {
        background: '#7F39FA',
        color: 'white',
        border: 'none',
      },
      hover: {
        background: '#6D28D9',
        color: '',
        border: '',
      },
      loading: {
        background: '#4C1D95',
        color: '',
        border: '',
      },
      disabled: {
        background: '#7F39FA',
        color: '',
        border: '',
      },
    },
    secondary: {
      default: {
        background: '#27272A',
        color: '#D4D4D8',
        border: '1px solid #3F3F46',
      },
      hover: {
        background: '',
        color: 'white',
        border: '',
      },
      loading: {
        background: '#3F3F46',
        color: '#D4D4D8',
        border: '1px solid #52525B',
      },
      disabled: {
        background: '#27272A',
        color: '#D4D4D8',
        border: '',
      },
    },
    tertiary: {
      default: {
        background: 'transparent',
        color: '#D4D4D8',
        border: '',
      },
      hover: {
        background: '#27272A',
        color: 'white',
        border: '',
      },
      loading: {
        background: '#3F3F46',
        color: '#D4D4D8',
        border: '',
      },
      disabled: {
        background: 'transparent',
        color: '#D4D4D8',
        border: '',
      },
    },
    'secondary-invert': {
      default: {
        background: '#E4E4E7',
        color: '#52525B',
        border: '1px solid #D4D4D8',
      },
      hover: {
        background: '',
        color: 'white',
        border: '',
      },
      loading: {
        background: '#D4D4D8',
        color: '#52525B',
        border: '1px solid #D4D4D8',
      },
      disabled: {
        background: '#E4E4E7',
        color: '#52525B',
        border: '',
      },
    }
  },
  input: {
    main: {
      default: {
        background: '#27272A',
        color: {
          text: 'white',
          placeholder: '#A1A1AA',
        },
        border: '1px solid #3F3F46',
      },
      hover: {
        background: '#27272A',
        color: {
          text: 'white',
          placeholder: 'white',
        },
        border: '1px solid #3F3F46',
      },
      error: {
        border: '1px solid #F43F5E',
        color: '#F43F5E'
      }
    }
  },
  snackbar: {
    // default: {
    //   background: '#18181B',
    //   border: '1px solid #27272A',
    // },
    error: {
      background: '#FAFAFA',
      border: '1px solid #E4E4E7',
      color: '#52525B',
    }
  },
  modal: {
    background: '#18181B',
    border: '1px solid rgba(255, 255, 255, 0.24)',
    boxShadow: '0px 1px 2px 0px #10182859',
    mobile: {
      borderTop: '1px solid #27272A'
    }
  },
  card: {
    primary: {
      default: {
        background: '#18181B',
        border: '1px solid #27272A'
      },
      hover: {
        background: '#27272A',
        border: '1px solid #3F3F46'
      },
      focus: {
        background: '#27272A',
        border: '1px solid white'
      }
    },
    secondary: {
      default: {
        background: '#27272A',
        border: '1px solid #3F3F46'
      }
    }
  },
  lang: {
    main: '#27272A'
  }
}